export default {
  "content": "<path d=\"M8.139 15.76a20.972 20.972 0 0013.72 6.158 21.095 21.095 0 00-6.14-13.762A20.972 20.972 0 002 2a21.08 21.08 0 006.139 13.762zm29.722 0a20.972 20.972 0 01-13.72 6.158 21.095 21.095 0 016.14-13.762A20.972 20.972 0 0144 2a21.08 21.08 0 01-6.139 13.762zm0 14.463a20.972 20.972 0 00-13.72-6.158 21.095 21.095 0 006.14 13.762A20.972 20.972 0 0044 43.984a21.08 21.08 0 00-6.139-13.761zm-29.722 0c3.65-3.676 8.61-5.873 13.79-6.16-.28 5.183-2.536 10.084-6.21 13.764A20.972 20.972 0 012 43.984a21.08 21.08 0 016.139-13.761z\"/>",
  "attrs": {
    "width": "46",
    "height": "46",
    "viewBox": "0 0 46 46",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};